module.exports = __webpack_public_path__ + "static/media/logo-white-letters.fca44f3c.png";